import { ServiceTimeoutError } from '../error-handling';
export async function startServiceTimeout(timeout, serviceName, rejectMessage) {
    // tslint:disable-next-line: no-inferred-empty-object-type
    await new Promise((resolve) => setTimeout(resolve, timeout));
    throw new ServiceTimeoutError(serviceName, rejectMessage);
}
